const configuration = {
    //BACKEND_URL: 'http://localhost:9000',
    BACKEND_URL: '/be',
}

export default configuration;
